import { CORE_HOTELS_NAME, CoreHotelsComponent } from "@b2bportal/core-types";

// Hotels Overrides
import hotelGuestCountPickerStyles from "./hotels/styles/GuestCountPicker.module.scss";
import hotelListStyles from "./hotels/styles/HotelList.module.scss";
import hotelsFintechMarketplacePageWrapperStyles from "./hotels/styles/HotelsFintechMarketplacePageWrapper.module.scss";

export const hotelStyleOverrides = {
  [CORE_HOTELS_NAME]: {
    [CoreHotelsComponent.GuestCountPicker]: hotelGuestCountPickerStyles,
    [CoreHotelsComponent.HotelList]: hotelListStyles,
    [CoreHotelsComponent.HotelsFintechMarketplacePageWrapper]:
      hotelsFintechMarketplacePageWrapperStyles,
  },
};
